// import React, { useState, useEffect } from "react";
// import { FiEdit, FiPlus, FiCheckCircle, FiPackage } from "react-icons/fi";

// const Packages = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showAddForm, setShowAddForm] = useState(false);
//   const [showEditForm, setShowEditForm] = useState(false);
//   const [currentPackage, setCurrentPackage] = useState(null);
//   const [formData, setFormData] = useState({
//     packageName: "",
//     price: "",
//     validity: "",
//     credit: "", // Added credit field
//     pointOne: "",
//     pointTwo: "",
//     pointThree: "",
//     pointFour: "",
//     pointFive: "",
//     pointSix: "",
//     pointSeven: "",
//     pointEight: "",
//     pointNine: "",
//     pointTen: "",
//   });

//   // Fetch all packages
//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`https://allyoutube-01-02d59d78beb5.herokuapp.com/packages`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch packages");
//       }
//       const data = await response.json();
//       setPackages(data);
//       setError(null);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch a single package
//   const fetchPackage = async (id) => {
//     try {
//       const response = await fetch(`https://allyoutube-01-02d59d78beb5.herokuapp.com/package/${id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch package");
//       }
//       const data = await response.json();
//       setCurrentPackage(data);
//       setFormData(data);
//       setShowEditForm(true);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Add a new package
//   const addPackage = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch("https://allyoutube-01-02d59d78beb5.herokuapp.com/add-package", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });
//       if (!response.ok) {
//         throw new Error("Failed to add package");
//       }
//       setShowAddForm(false);
//       setFormData({
//         packageName: "",
//         price: "",
//         validity: "",
//         credit: "", // Reset credit field
//         pointOne: "",
//         pointTwo: "",
//         pointThree: "",
//         pointFour: "",
//         pointFive: "",
//         pointSix: "",
//         pointSeven: "",
//         pointEight: "",
//         pointNine: "",
//         pointTen: "",
//       });
//       fetchPackages();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Update a package
//   const updatePackage = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(
//         `https://allyoutube-01-02d59d78beb5.herokuapp.com/edit-package/${currentPackage._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );
//       if (!response.ok) {
//         throw new Error("Failed to update package");
//       }
//       setShowEditForm(false);
//       setCurrentPackage(null);
//       fetchPackages();
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Render package features as list items
//   const renderFeatures = (pkg) => {
//     const features = [
//       pkg.pointOne,
//       pkg.pointTwo,
//       pkg.pointThree,
//       pkg.pointFour,
//       pkg.pointFive,
//       pkg.pointSix,
//       pkg.pointSeven,
//       pkg.pointEight,
//       pkg.pointNine,
//       pkg.pointTen,
//     ].filter(Boolean);
//     return features.map((feature, index) => (
//       <li key={index} className="mb-2">
//         <FiCheckCircle className="text-success me-2" />
//         {feature}
//       </li>
//     ));
//   };

//   return (
//     <div className="container py-5">
//       {/* Header */}
//       <div className="row mb-4">
//         <div className="col d-flex justify-content-between align-items-center">
//           <h3 className="fw-bold text-dark">
//             <FiPackage className="me-2 " />
//             Pricing Packages
//           </h3>
//           <button
//             className="btn btn-primary"
//             onClick={() => setShowAddForm(true)}
//             disabled={packages.length >= 3}
//             title={packages.length >= 3 ? "Maximum 3 packages allowed" : ""}
//           >
//             <FiPlus className="me-1" /> Add Package
//           </button>
//         </div>
//       </div>

//       {/* Error Alert */}
//       {error && (
//         <div className="alert alert-danger" role="alert">
//           {error}
//         </div>
//       )}

//       {/* Loading Spinner */}
//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden"></span>
//           </div>
//           <p className="mt-3">Loading packages...</p>
//         </div>
//       ) : (
//         <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//           {packages.map((pkg) => (
//             <div key={pkg._id} className="col">
//               <div className="card h-100 shadow-sm">
//                 <div className="card-header bg-primary text-white text-center py-3">
//                   <h3 className="mb-0">{pkg.packageName}</h3>
//                 </div>
//                 <div className="card-body d-flex flex-column">
//                   <div className="text-center mb-4">
//                     <h2 className="display-5 fw-bold text-dark">
//                       ${pkg.price}
//                     </h2>
//                     <p className="text-muted">{pkg.credit} Credits</p>
//                   </div>
//                   <ul className="list-unstyled mb-4">{renderFeatures(pkg)}</ul>
//                   <div className="mt-auto text-center">
//                     <button
//                       className="btn btn-outline-primary"
//                       onClick={() => fetchPackage(pkg._id)}
//                     >
//                       <FiEdit className="me-1" /> Edit
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//           {packages.length === 0 && !loading && (
//             <div className="col-12 text-center py-5">
//               <p className="text-muted">
//                 No packages available. Add a new package to get started.
//               </p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add Package Form */}
//       {showAddForm && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg" role="document">
//             <div className="modal-content">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title">Add New Package</h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowAddForm(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={addPackage}>
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label htmlFor="packageName" className="form-label text-dark">
//                         Package Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="packageName"
//                         name="packageName"
//                         value={formData.packageName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="price" className="form-label text-dark">
//                         Price
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="price"
//                         name="price"
//                         value={formData.price}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="credit" className="form-label text-dark">
//                         Credits
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         id="credit"
//                         name="credit"
//                         value={formData.credit}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointOne" className="form-label text-dark">
//                         Feature 1
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointOne"
//                         name="pointOne"
//                         value={formData.pointOne}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTwo" className="form-label text-dark">
//                         Feature 2
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTwo"
//                         name="pointTwo"
//                         value={formData.pointTwo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointThree" className="form-label text-dark">
//                         Feature 3
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointThree"
//                         name="pointThree"
//                         value={formData.pointThree}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFour" className="form-label text-dark">
//                         Feature 4
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFour"
//                         name="pointFour"
//                         value={formData.pointFour}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFive" className="form-label text-dark">
//                         Feature 5
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFive"
//                         name="pointFive"
//                         value={formData.pointFive}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSix" className="form-label text-dark">
//                         Feature 6
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSix"
//                         name="pointSix"
//                         value={formData.pointSix}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSeven" className="form-label text-dark">
//                         Feature 7
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSeven"
//                         name="pointSeven"
//                         value={formData.pointSeven}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointEight" className="form-label text-dark">
//                         Feature 8
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointEight"
//                         name="pointEight"
//                         value={formData.pointEight}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointNine" className="form-label text-dark">
//                         Feature 9
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointNine"
//                         name="pointNine"
//                         value={formData.pointNine}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTen" className="form-label text-dark">
//                         Feature 10
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTen"
//                         name="pointTen"
//                         value={formData.pointTen}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-4 d-flex justify-content-end">
//                     <button
//                       type="button"
//                       className="btn btn-secondary me-2"
//                       onClick={() => setShowAddForm(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       Save Package
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Package Form */}
//       {showEditForm && currentPackage && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           role="dialog"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg" role="document">
//             <div className="modal-content">
//               <div className="modal-header bg-primary text-white">
//                 <h5 className="modal-title">Edit Package</h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-white"
//                   onClick={() => setShowEditForm(false)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <form onSubmit={updatePackage}>
//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label htmlFor="packageName" className="form-label text-dark">
//                         Package Name
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="packageName"
//                         name="packageName"
//                         value={formData.packageName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="price" className="form-label text-dark">
//                         Price
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="price"
//                         name="price"
//                         value={formData.price}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label htmlFor="credit" className="form-label text-dark">
//                         Credits
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         id="credit"
//                         name="credit"
//                         value={formData.credit}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointOne" className="form-label text-dark">
//                         Feature 1
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointOne"
//                         name="pointOne"
//                         value={formData.pointOne}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTwo" className="form-label text-dark">
//                         Feature 2
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTwo"
//                         name="pointTwo"
//                         value={formData.pointTwo}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointThree" className="form-label text-dark">
//                         Feature 3
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointThree"
//                         name="pointThree"
//                         value={formData.pointThree}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFour" className="form-label text-dark">
//                         Feature 4
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFour"
//                         name="pointFour"
//                         value={formData.pointFour}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointFive" className="form-label text-dark">
//                         Feature 5
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointFive"
//                         name="pointFive"
//                         value={formData.pointFive}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSix" className="form-label text-dark">
//                         Feature 6
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSix"
//                         name="pointSix"
//                         value={formData.pointSix}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointSeven" className="form-label text-dark">
//                         Feature 7
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointSeven"
//                         name="pointSeven"
//                         value={formData.pointSeven}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointEight" className="form-label text-dark">
//                         Feature 8
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointEight"
//                         name="pointEight"
//                         value={formData.pointEight}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointNine" className="form-label text-dark">
//                         Feature 9
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointNine"
//                         name="pointNine"
//                         value={formData.pointNine}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label htmlFor="pointTen" className="form-label text-dark">
//                         Feature 10
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         id="pointTen"
//                         name="pointTen"
//                         value={formData.pointTen}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="mt-4 d-flex justify-content-end">
//                     <button
//                       type="button"
//                       className="btn btn-secondary me-2"
//                       onClick={() => setShowEditForm(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button type="submit" className="btn btn-primary">
//                       Update Package
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Packages;

import React, { useState, useEffect } from "react";
import { FiEdit, FiPlus, FiCheckCircle, FiPackage, FiX } from "react-icons/fi";

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [currentPackage, setCurrentPackage] = useState(null);
  const [formData, setFormData] = useState({
    packageName: "",
    price: "",
    validity: "",
    credit: "", // Added credit field
    pointOne: "",
    pointTwo: "",
    pointThree: "",
    pointFour: "",
    pointFive: "",
    pointSix: "",
    pointSeven: "",
    pointEight: "",
    pointNine: "",
    pointTen: "",
  });

  // Fetch all packages
  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    setLoading(true);
    try {
      const response = await fetch(`https://allyoutube-01-02d59d78beb5.herokuapp.com/packages`);
      if (!response.ok) {
        throw new Error("Failed to fetch packages");
      }
      const data = await response.json();
      setPackages(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch a single package
  const fetchPackage = async (id) => {
    try {
      const response = await fetch(`https://allyoutube-01-02d59d78beb5.herokuapp.com/package/${id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch package");
      }
      const data = await response.json();
      setCurrentPackage(data);
      setFormData(data);
      setShowEditForm(true);
    } catch (err) {
      setError(err.message);
    }
  };

  // Add a new package
  const addPackage = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://allyoutube-01-02d59d78beb5.herokuapp.com/add-package", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error("Failed to add package");
      }
      setShowAddForm(false);
      setFormData({
        packageName: "",
        price: "",
        validity: "",
        credit: "", // Reset credit field
        pointOne: "",
        pointTwo: "",
        pointThree: "",
        pointFour: "",
        pointFive: "",
        pointSix: "",
        pointSeven: "",
        pointEight: "",
        pointNine: "",
        pointTen: "",
      });
      fetchPackages();
    } catch (err) {
      setError(err.message);
    }
  };

  // Update a package
  const updatePackage = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://allyoutube-01-02d59d78beb5.herokuapp.com/edit-package/${currentPackage._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to update package");
      }
      setShowEditForm(false);
      setCurrentPackage(null);
      fetchPackages();
    } catch (err) {
      setError(err.message);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Render package features as list items
  const renderFeatures = (pkg) => {
    const features = [
      pkg.pointOne,
      pkg.pointTwo,
      pkg.pointThree,
      pkg.pointFour,
      pkg.pointFive,
      pkg.pointSix,
      pkg.pointSeven,
      pkg.pointEight,
      pkg.pointNine,
      pkg.pointTen,
    ].filter(Boolean);
    return features.map((feature, index) => (
      <li key={index} className="d-flex align-items-start mb-3">
        <FiCheckCircle className="text-success mt-1 me-2 flex-shrink-0" />
        <span className="text-secondary">{feature}</span>
      </li>
    ));
  };

  return (
    <div className="container py-5">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-5">
        <div>
          <h2 className="fw-bold text-white mb-1">
            <FiPackage className="me-2 text-primary" />
            Pricing Packages
          </h2>
          <p className="text-muted mb-0">Manage your subscription plans</p>
        </div>
        <button
          className="btn btn-primary rounded-pill px-4 shadow-sm"
          onClick={() => setShowAddForm(true)}
          disabled={packages.length >= 3}
        >
          <FiPlus className="me-2" /> Add New Package
        </button>
      </div>

      {/* Error Alert */}
      {error && (
        <div className="alert alert-danger shadow-sm border-0 rounded-3 mb-4" role="alert">
          <i className="bi bi-exclamation-circle me-2"></i> {error}
        </div>
      )}

      {/* Loading State */}
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Loading packages...</p>
        </div>
      ) : (
        /* Package Grid */
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {packages.map((pkg) => (
            <div key={pkg._id} className="col">
              <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden hover-shadow transition-all">
                {/* Card Header */}
                <div className="card-header bg-primary bg-gradient p-4 text-center border-0">
                  <h4 className="text-white fw-bold mb-0">{pkg.packageName}</h4>
                </div>
                
                {/* Card Body */}
                <div className="card-body p-4 d-flex flex-column">
                  <div className="text-center mb-4 pb-3 border-bottom">
                    <h2 className="display-4 fw-bold text-dark mb-0">
                      ${pkg.price}
                    </h2>
                    <div className="d-flex justify-content-center align-items-center gap-2 mt-2">
                         <span className="badge bg-light text-primary border border-primary rounded-pill px-3">
                            {pkg.credit} Credits
                         </span>
                        
                    </div>
                  </div>
                  
                  <div className="flex-grow-1">
                    <ul className="list-unstyled mb-0">
                        {renderFeatures(pkg)}
                    </ul>
                  </div>

                  <div className="mt-4 pt-3 text-center">
                    <button
                      className="btn btn-outline-primary rounded-pill w-100 py-2 fw-medium"
                      onClick={() => fetchPackage(pkg._id)}
                    >
                      <FiEdit className="me-2" /> Edit Package
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Empty State */}
          {packages.length === 0 && !loading && (
            <div className="col-12 text-center py-5">
              <div className="mb-3 text-muted opacity-25">
                 <FiPackage size={64} />
              </div>
              <h5 className="text-dark">No packages found</h5>
              <p className="text-muted">Create a new pricing package to get started.</p>
            </div>
          )}
        </div>
      )}

      {/* --- ADD PACKAGE MODAL --- */}
      {showAddForm && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header bg-primary text-white px-4 py-3 border-0">
                <h5 className="modal-title fw-bold">Add New Package</h5>
                <button
                  type="button"
                  className="btn text-white p-0"
                  onClick={() => setShowAddForm(false)}
                  style={{ background: 'transparent', border: 'none' }}
                >
                    <FiX size={24} />
                </button>
              </div>
              <div className="modal-body p-4">
                <form onSubmit={addPackage} id="addForm">
                  <h6 className="text-uppercase text-muted fw-bold small mb-3">Basic Information</h6>
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="packageName"
                          name="packageName"
                          placeholder="Name"
                          value={formData.packageName}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="packageName">Package Name</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            id="price"
                            name="price"
                            placeholder="Price"
                            value={formData.price}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="price">Price ($)</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                       <div className="form-floating">
                        <input
                            type="number"
                            className="form-control"
                            id="credit"
                            name="credit"
                            placeholder="Credits"
                            value={formData.credit}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="credit">Credits</label>
                      </div>
                    </div>
                    <div className="col-md-12">
                       <div className="form-floating">
                        <input
                            type="number"
                            className="form-control"
                            id="validity"
                            name="validity"
                            placeholder="Days"
                            value={formData.validity || ""}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="validity">Validity (Days)</label>
                      </div>
                    </div>
                  </div>

                  <h6 className="text-uppercase text-muted fw-bold small mb-3">Features List</h6>
                  <div className="row g-3">
                    {[
                      { name: "pointOne", label: "Feature 1" },
                      { name: "pointTwo", label: "Feature 2" },
                      { name: "pointThree", label: "Feature 3" },
                      { name: "pointFour", label: "Feature 4" },
                      { name: "pointFive", label: "Feature 5" },
                      { name: "pointSix", label: "Feature 6" },
                      { name: "pointSeven", label: "Feature 7" },
                      { name: "pointEight", label: "Feature 8" },
                      { name: "pointNine", label: "Feature 9" },
                      { name: "pointTen", label: "Feature 10" },
                    ].map((field, idx) => (
                      <div className="col-md-6" key={idx}>
                        <div className="input-group">
                           <span className="input-group-text bg-light text-secondary border-end-0">
                              <FiCheckCircle size={14} />
                           </span>
                           <input
                              type="text"
                              className="form-control border-start-0 ps-0"
                              placeholder={field.label}
                              name={field.name}
                              value={formData[field.name]}
                              onChange={handleChange}
                            />
                        </div>
                      </div>
                    ))}
                  </div>
                </form>
              </div>
              <div className="modal-footer border-top-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4"
                  onClick={() => setShowAddForm(false)}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  form="addForm" 
                  className="btn btn-primary rounded-pill px-4"
                >
                  Save Package
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --- EDIT PACKAGE MODAL --- */}
      {showEditForm && currentPackage && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header bg-primary text-white px-4 py-3 border-0">
                <h5 className="modal-title fw-bold">Edit Package</h5>
                 <button
                  type="button"
                  className="btn text-white p-0"
                  onClick={() => setShowEditForm(false)}
                  style={{ background: 'transparent', border: 'none' }}
                >
                    <FiX size={24} />
                </button>
              </div>
              <div className="modal-body p-4">
                <form onSubmit={updatePackage} id="editForm">
                  <h6 className="text-uppercase text-muted fw-bold small mb-3">Basic Information</h6>
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="packageName"
                          name="packageName"
                          placeholder="Name"
                          value={formData.packageName}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="packageName" className="text-dark">Package Name</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            id="price"
                            name="price"
                            placeholder="Price"
                            value={formData.price}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="price" className="text-dark">Price ($)</label>
                      </div>
                    </div>
                    <div className="col-md-3">
                       <div className="form-floating">
                        <input
                            type="number"
                            className="form-control"
                            id="credit"
                            name="credit"
                            placeholder="Credits"
                            value={formData.credit}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="credit" className="text-dark">Credits</label>
                      </div>
                    </div>
                   
                  </div>

                  <h6 className="text-uppercase text-muted fw-bold small mb-3">Features List</h6>
                  <div className="row g-3">
                    {[
                      { name: "pointOne", label: "Feature 1" },
                      { name: "pointTwo", label: "Feature 2" },
                      { name: "pointThree", label: "Feature 3" },
                      { name: "pointFour", label: "Feature 4" },
                      { name: "pointFive", label: "Feature 5" },
                      { name: "pointSix", label: "Feature 6" },
                      { name: "pointSeven", label: "Feature 7" },
                      { name: "pointEight", label: "Feature 8" },
                      { name: "pointNine", label: "Feature 9" },
                      { name: "pointTen", label: "Feature 10" },
                    ].map((field, idx) => (
                      <div className="col-md-6" key={idx}>
                         <div className="input-group">
                           <span className="input-group-text bg-light text-secondary border-end-0">
                              <FiCheckCircle size={14} />
                           </span>
                           <input
                              type="text"
                              className="form-control border-start-0 ps-0"
                              placeholder={field.label}
                              name={field.name}
                              value={formData[field.name]}
                              onChange={handleChange}
                            />
                        </div>
                      </div>
                    ))}
                  </div>
                </form>
              </div>
              <div className="modal-footer border-top-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4"
                  onClick={() => setShowEditForm(false)}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  form="editForm" 
                  className="btn btn-primary rounded-pill px-4"
                >
                  Update Package
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Packages;